<mat-card class="cardWithShadow theme-card m-0">
    <mat-card-content class="confirmation">
        <h2 class="f-w-500">Confirmation</h2>
        <p>{{Data?.message}}</p>
        <div class="action-btn">
            <button mat-flat-button color="default" class="w-50" (click)="active(false)">No</button>
            <button mat-flat-button color="primary" class="w-50" (click)="active(true)">Yes</button> 
        </div>
    </mat-card-content>
</mat-card>